import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms'
import { normalizeRegistrationNumber, REGISTRATION_NUMBER_PATTERN } from '../utils/registration-number'

export class CustomValidators {
  static zeroIsNotAllowedErrorMessage = 'Die Eingabe darf nicht mit 0 starten.'
  static threeDecimalsErrorMessage = 'Es sind maximal 3 Nachkommastellen erlaubt.'
  static minMaxPercentageErrorMessage = 'Die Eingabe muss zwischen 0 und 100 liegen.'
  static geoCoordinatesPatternErrorMessage = 'Die Eingabe muss 3 bis 14 Nachkommastellen haben.'
  static registrationNumberFormatErrorMessage =
    'Die Registernummer besteht aus Ziffern und optional 1–2 Buchstaben am Ende.'

  static zeroIsNotAllowedAsFirstCharacter(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value != null ? String(control.value) : ''

      if (value.startsWith('0') && value.length > 0) {
        return { zeroIsNotAllowed: true }
      }

      return null
    }
  }

  static registrationNumberFormat(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const compact = normalizeRegistrationNumber(control.value)
      if (!compact) return null
      return REGISTRATION_NUMBER_PATTERN.test(compact) ? null : { registrationNumberFormat: true }
    }
  }
}
